// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Actions
import { getSeoPreferencesList } from "./get-seo-preferences-list.action";

// ############################################################

// Initial state
const initialState = {
	loading: false,
	loaded: false,
	success: false,
	error: false,
	data: {
		preferences: [],
		total: 0,
	},
};

// ############################################################

// Slice
const mainPageSeoPreferencesListSlice = createSlice({
	name: "mainPages/seoPreferencesList",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// getSeoPreferencesList
			.addCase(getSeoPreferencesList.pending, (state) => {
				state.loading = true;
			})
			.addCase(getSeoPreferencesList.fulfilled, (state, action) => {
				state.loading = false;
				state.loaded = true;
				state.success = true;
				state.error = false;
				state.data = {
					...state.data,
					preferences: action.payload.data?.data || [],
					total: action.payload.data?.total,
				};
			})
			.addCase(getSeoPreferencesList.rejected, (state) => {
				state.loading = false;
				state.loaded = true;
				state.success = false;
				state.error = true;
			});
	},
});

// ############################################################

export default mainPageSeoPreferencesListSlice.reducer;

// ############################################################
